import _ from 'lodash'
import channels from '@feedyou-ai/feedbot-schema/schema/channels.json'
import { ChannelSchema } from '@feedyou/schema'

import { UserAuthInfo } from '../../../store/user/types'
import { generateId } from '../../../lib/generateId'

export function generateChannelsId(channels: any) {
  if (!Array.isArray(channels)) {
    return channels
  }

  return channels.map((channel: any) => {
    if (channel.id) {
      return channel
    }

    return { ...channel, id: generateId.channelId() }
  })
}

export function adjustSchema(
  user: UserAuthInfo,
  isTelephonyAvailable: boolean,
  isRealtimeAvailable: boolean
) {
  const schema = _.cloneDeep(channels)

  // keep only Feedyou & Both options for non-feedies
  if (
    !user.email?.includes('@feedyou.') &&
    schema?.items?.anyOf?.[0]?.properties?.signature?.anyOf
  ) {
    const modesWithFeedyou = schema.items.anyOf[0].properties.signature.anyOf.slice(0, 2)
    schema.items.anyOf[0].properties.signature.anyOf = modesWithFeedyou
  }

  // remove telephony section if bot hosting does not support it yet
  if (!isTelephonyAvailable) {
    schema.items.anyOf = schema.items.anyOf.filter(
      channel => channel.properties.type.const !== 'telephony'
    )
  }

  // remove realtime section if bot hosting does does not have it configured
  if (!isRealtimeAvailable) {
    schema.items.anyOf = schema.items.anyOf.filter(
      channel => channel.properties.type.const !== 'realtime'
    )
  }

  // @ts-ignore
  delete schema.title

  return schema
}

export function adjustTelephonyChannelPropertiesForDialer(
  channels: ChannelSchema[]
): ChannelSchema[] {
  const telephonyChannelIndex = channels?.findIndex(channel => channel.type === 'telephony')
  if (_.isUndefined(telephonyChannelIndex) || telephonyChannelIndex < 0) {
    return channels
  }

  if (channels[telephonyChannelIndex]?.pbx?.dialer) {
    return channels
  }

  const channelsCopy = _.cloneDeep(channels)
  channelsCopy[telephonyChannelIndex].campaigns = []
  return channelsCopy
}
